var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3438,
    cy: 15.9844,
    r: 15,
    fill: "#5418F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 17.3454L13.3386 20.3196L21.3386 12.375",
    fill: "#5418F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 17.3454L13.3386 20.3196L21.3386 12.375",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d7344bbacc0061e697f6c52740e7bc9a.svg";
export { ForwardRef as ReactComponent };